import { getSearchEngineForceStubScript } from '~/utils/searchEngineForce'

/**
 * Emits the `window.kftSearchEngine.force` stub into <head> (KFT-4115). Must be
 * called in app.vue before any A/B tool loader (useMidaScript, useVwoScript) so
 * the tool can force an engine before the app hydrates.
 */
export const useSearchEngineForceHead = () => {
  useHead({
    script: [
      {
        key: 'kftSearchEngineForce',
        innerHTML: getSearchEngineForceStubScript(),
        type: 'text/javascript',
        // Ahead of the A/B tool loaders regardless of useHead call order.
        tagPriority: 'critical',
      },
    ],
  })
}
